/* ============================================================
   ETCHED LASER LAB — Main JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Mobile Menu ── */
  const hamburger = document.getElementById('nav-hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileClose = document.getElementById('mobile-menu-close');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    mobileClose && mobileClose.addEventListener('click', closeMobileMenu);
    mobileMenu.addEventListener('click', (e) => {
      if (e.target === mobileMenu) closeMobileMenu();
    });
  }
  function closeMobileMenu() {
    mobileMenu && mobileMenu.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ── Cart Sidebar ── */
  const cartTrigger = document.getElementById('cart-trigger');
  const cartSidebar = document.getElementById('cart-sidebar');
  const cartClose   = document.getElementById('cart-close');
  const cartOverlay = document.getElementById('cart-overlay');

  if (cartTrigger) {
    cartTrigger.addEventListener('click', () => {
      cartSidebar && cartSidebar.classList.add('open');
      cartOverlay && cartOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  [cartClose, cartOverlay].forEach(el => {
    el && el.addEventListener('click', closeCart);
  });
  function closeCart() {
    cartSidebar && cartSidebar.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ── Accordion ── */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      // Close all siblings
      const siblings = item.parentElement.querySelectorAll('.accordion-item');
      siblings.forEach(s => s.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── Product Gallery Thumbnails ── */
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-gallery');
      gallery.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      // Swap main image src from data-src on the thumb
      const mainImg = gallery.querySelector('.product-gallery-main img');
      const newSrc = thumb.dataset.src;
      if (mainImg && newSrc) {
        mainImg.src = newSrc;
        mainImg.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : mainImg.alt;
      }
    });
  });

  /* ── Variant Pills ── */
  document.querySelectorAll('.variant-pills').forEach(group => {
    group.querySelectorAll('.variant-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        group.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
        // Price update is handled by the inline product script (multi-option aware)
      });
    });
  });

  /* ── Quantity Selector ── */
  document.querySelectorAll('.qty-selector').forEach(selector => {
    const input = selector.querySelector('.qty-input');
    selector.querySelector('.qty-minus') && selector.querySelector('.qty-minus').addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    selector.querySelector('.qty-plus') && selector.querySelector('.qty-plus').addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });

  /* ── Add to Cart — handled by cart.js ── */

  /* ── Shop filter (category sidebar) ── */
  document.querySelectorAll('.filter-option').forEach(option => {
    option.addEventListener('click', () => {
      const checkbox = option.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.checked = !checkbox.checked;
        option.classList.toggle('active', checkbox.checked);
        filterProducts();
      }
    });
  });

  function filterProducts() {
    const checked = Array.from(document.querySelectorAll('.filter-option input:checked'))
      .map(cb => cb.value);
    const cards = document.querySelectorAll('.product-card[data-category]');
    if (checked.length === 0) {
      cards.forEach(c => c.style.display = '');
    } else {
      cards.forEach(c => {
        const cat = c.dataset.category;
        c.style.display = checked.includes(cat) ? '' : 'none';
      });
    }
    // Update count
    const visible = Array.from(cards).filter(c => c.style.display !== 'none').length;
    const countEl = document.querySelector('.shop-count');
    if (countEl) countEl.textContent = (visible || cards.length) + ' products';
  }

  /* ── Auto-filter from URL ?cat= param ── */
  const urlCat = new URLSearchParams(window.location.search).get('cat');
  if (urlCat) {
    const cb = document.querySelector(`.filter-option input[value="${urlCat}"]`);
    if (cb) {
      cb.checked = true;
      cb.closest('.filter-option').classList.add('active');
      filterProducts();
      // Scroll to products
      const grid = document.querySelector('.products-grid');
      if (grid) setTimeout(() => grid.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
    }
  }

  /* ── Contact Form ── */
  const contactForm = document.getElementById('contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = contactForm.querySelector('button[type="submit"]');
      const original = btn.textContent;
      btn.textContent = 'Message Sent ✓';
      btn.style.background = 'var(--green-dark)';
      btn.disabled = true;
      // Reset after 3 seconds
      setTimeout(() => {
        btn.textContent = original;
        btn.style.background = '';
        btn.disabled = false;
        contactForm.reset();
      }, 3000);
    });
  }

  /* ── Smooth scroll for anchor links ── */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        closeMobileMenu();
      }
    });
  });

  /* ── Sticky nav shadow on scroll ── */
  const nav = document.querySelector('.nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.boxShadow = window.scrollY > 20
        ? '0 2px 16px rgba(28,26,24,.12)'
        : '0 1px 3px rgba(28,26,24,.08)';
    }, { passive: true });
  }

  /* ── Character counter for personalisation textarea ── */
  document.querySelectorAll('textarea[maxlength]').forEach(ta => {
    const hint = ta.nextElementSibling;
    if (hint && hint.classList.contains('field-hint')) {
      const max = ta.getAttribute('maxlength');
      ta.addEventListener('input', () => {
        hint.textContent = `${ta.value.length} / ${max} characters`;
      });
    }
  });

});
